import script from "./RedGreenView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RedGreenView.vue?vue&type=script&lang=ts&setup=true"

import "./RedGreenView.vue?vue&type=style&index=0&id=295c6346&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295c6346"]])

export default __exports__